// ** Custom Hooks
import useJwt from '@src/auth/jwt/useJwt'

export default class MainApiService {

    getCompanyLogo() {
        return useJwt.axiosGet('/api/company_logo', {withCredentials: false})
    }

    getInfoFile(type, parking) {
        return useJwt.axiosGet(`/api/info_file/${type}/check/${parking}`, {withCredentials: false})
    }

    getInfoFileDownloadLink(type, parking) {
        return `/api/info_file/${type}/download/${parking}`
    }

    uploadInfoFileLink(type, parking, data) {
        return useJwt.axiosPost(`/api/administration/parking/update_parameter/${type}/${parking}`, data)
    }

    checkAuth() {
        return useJwt.axiosPost('/api/security/check_auth')
    }

    getCompanyData(...args) {
        return useJwt.axiosPost('/api/utils/biznes_gov_data', ...args)
    }

    getPostalCodeData(...args) {
        return useJwt.axiosPost('/api/utils/postal_code', ...args)
    }
}